export default __webpack_public_path__ + "static/media/1.cb7163c6.png";